module.exports = __webpack_public_path__ + "img/landscape-basic.fd6d5325.jpg";